import merge from 'lodash/merge';

import { config } from './config';

import tmpUntranslated from '../public/locales/tmp-untranslated.json';
import { enUS } from '../public/locales/languages';
import { InitOptions } from 'i18next';

export const smartlingNamespaces = [
    'programs',
    'translation',
    'auth',
    'circles',
    'dashboard',
    'user',
    'validation',
    'providers',
    'shared',
    'goals',
    'onboarding',
    'videoSessions',
    'admin',
    'assessments',
    'intakeForms',
    'dailyPause',
    'insuranceForm',
    'courses',
    'payments',
    'dependents',
    'benefits',
    'care',
    'messaging',
    'careNavigation',
    'vita',
] as const;

export const i18nLanguages = [
    'en-US',
    'fr-CA',
    'zh-Hans',
    'ko',
    'fr',
    'ja',
    'es',
    'de',
    'hi',
    'pt',
    'pl',
    'it',
    'ms',
] as const;

type SupportedLocale = (typeof i18nLanguages)[number];

export const smartlingLocales = [
    'en-US',
    'fr-CA',
    'zh-CN',
    'ko-KR',
    'fr-FR',
    'ja-JP',
    'es-LA',
    'de-DE',
    'hi-IN',
    'pt-BR',
    'pl-PL',
    'it-IT',
    'ms-MY',
] as const;

type SmartlingLocale = (typeof smartlingLocales)[number];

export const i18nLanguageToSmartlingLanguage: Record<SupportedLocale, SmartlingLocale> = {
    'en-US': 'en-US',
    'fr-CA': 'fr-CA',
    'zh-Hans': 'zh-CN',
    ko: 'ko-KR',
    fr: 'fr-FR',
    ja: 'ja-JP',
    es: 'es-LA',
    de: 'de-DE',
    hi: 'hi-IN',
    pt: 'pt-BR',
    pl: 'pl-PL',
    it: 'it-IT',
    ms: 'ms-MY',
} as const;

type LanguageName =
    | 'English'
    | 'French Canadian'
    | 'French'
    | 'Korean'
    | 'Mandarin'
    | 'Spanish'
    | 'Japanese'
    | 'German'
    | 'Portuguese'
    | 'Hindi'
    | 'Polish'
    | 'Italian'
    | 'Malay';

// This list of languages are the real supported languages, that includes default languages as
// fr or es.
export const languageNameToI18nLanguage: Record<LanguageName, SupportedLocale> = {
    English: 'en-US',
    'French Canadian': 'fr-CA',
    French: 'fr',
    Korean: 'ko',
    Mandarin: 'zh-Hans',
    Spanish: 'es',
    Japanese: 'ja',
    German: 'de',
    Portuguese: 'pt',
    Hindi: 'hi',
    Polish: 'pl',
    Italian: 'it',
    Malay: 'ms',
};

const resources = {
    'en-US': merge(enUS, tmpUntranslated),
};

export const i18nConfig: InitOptions = {
    resources,
    fallbackLng: config.defaultLanguage,
    partialBundledLanguages: true,
    ns: [...smartlingNamespaces],
    supportedLngs: [...i18nLanguages],
    interpolation: {
        escapeValue: false,
    },
    cleanCode: true,
    keySeparator: false,
};
